import React, { Component } from 'react';

import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';

import faqHeaderBg from '../../assets/images/faqBg.png'
import FaCircle from 'react-icons/lib/fa/circle'
import FaAngleDown from "react-icons/lib/fa/angle-down"
import Footer from '../../components/Footer'


import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux'
// import {FaqContent}  from './faqContent'

import './Faq.css'

class Faq extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({
            content: [
                {
                    question: 'faq-question-1',
                    answers: [
                        'faq-answer-1'
                    ]
                },
                {
                    question: 'faq-question-2',
                    answers: [
                        'faq-answer-2'
                    ]
                },
                {
                    question: 'faq-question-3',
                    answers: [
                        'faq-answer-3-1',
                        'faq-answer-3-2'
                    ]
                },
                {
                    question: 'faq-question-4',
                    answers: [
                        'faq-answer-4-1',
                        'faq-answer-4-2',
                        'faq-answer-4-3',
                    ]
                },
                {
                    question: 'faq-question-5',
                    answers: [
                        'faq-answer-5-1',
                    ]
                },
                {
                    question: 'faq-question-6',
                    answers: [
                        'faq-answer-6-1'
                    ]
                },
                {
                    question: 'faq-question-7',
                    answers: [
                        'faq-answer-7-1'
                    ]
                },
                {
                    question: 'faq-question-8',
                    answers: [
                        'faq-answer-8-1'
                    ]
                },
                {
                    question: 'faq-question-9',
                    answers: [
                        'faq-answer-9-1'
                    ]
                },
                {
                    question: 'faq-question-10',
                    answers: [
                        'faq-answer-10-1',
                    ]
                },
                {
                    question: 'faq-question-11',
                    answers: [
                        'faq-answer-11-1',
                        'faq-answer-11-2',
                        'faq-answer-11-3',
                        'faq-answer-11-4'
                    ]
                },
                {
                    question: 'faq-question-12',
                    answers: [
                        'faq-answer-12-1',
                    ]
                },
                {
                    question: 'faq-question-13',
                    answers: [
                        'faq-answer-13-1',
                        'faq-answer-13-2',
                        'faq-answer-13-3',
                        'faq-answer-13-4',
                    ]
                },
                {
                    question: 'faq-question-14',
                    answers: [
                        'faq-answer-14-1',
                    ]
                },
            ]
        })

    }

    handleFaqItemToggle = (e) => {
        e.target.nextSibling.classList.toggle("faq-item-content-toggle")
        e.target.childNodes[1].classList.toggle("faq-arrow-toggle")
    }

    render() {
        return (
            <div className="faq-container">
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                <div className="faq-header">
                    <div className="faq-header-wrapper"></div>
                    <div className="faq-header-content">
                        <div className="faq-header-text">
                            <h1>{this.props.translate("faq-title")}</h1>
                            {/* <h5>{this.props.translate("PolicySearchPortalByIndividualPersons")}</h5> */}
                        </div>
                    </div>
                </div>


                <div className="faq-content">
                    <div className="faq-content-center">

                        {
                            this.state.content.map((item, index) => {
                                return (
                                    <div className="faq-item">
                                        <div className="faq-item-header" id={"faq-item-header-" + index} onClick={this.handleFaqItemToggle}>
                                            <span>{this.props.translate(item.question)}</span>
                                            <div className="faq-arrow" id={"faq-arrow-" + index}>
                                                <FaAngleDown />
                                            </div>

                                        </div>
                                        <div className="faq-item-content">
                                            <ul>
                                                {
                                                    item.answers.map((answer) => {
                                                        return (
                                                            <li>
                                                                <div className="faq-item-content-dot">
                                                                    <FaCircle />
                                                                </div>
                                                                <div className="faq-item-content-text">
                                                                    <span>
                                                                        {this.props.translate(answer)}
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>{/* faq-content-center      */}
                </div>
                <Footer />

            </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),

})
export default connect(mapStateToProps)(Faq)



// WEBPACK FOOTER //
// ./src/pages/FAQ/Faq.js